/**
 * 卡券中心
 */
import React from 'react';
import styles from './index.module.scss';
import { XSelect, XOKButton, XCancelButton, XInput, XDatePicker, } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message, } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import InventoryModal from '../../modal/InventoryModal';
import PopconfirmModal from '../../modal/PopconfirmModal';
import DeleteModal from '../../modal/DeleteModal';
import model from '@/reducers/market/cardcentre/model';
import ActivityDate from '../../modal/ActivityDate';


class Marketing extends React.PureComponent {

    state = {
        type: {},//卡券类型
        push: {},//推送平台
        state: {},//发放状态
        cardTicket: '',//卡券名称
        orderStartTime: null, //发放时间开始时间
        startPickerDisabled: false, // 发放时间开始时间不可选
        orderEndTime: null, // 发放时间结束时间
        endPickerDisabled: false, // 发放时间结束时间不可选
        status: {},//启用状态
        currentOpenMode: '', // 当前需要打开的弹窗signTime
        openModeParam: {}, // 当前需要打开的弹窗的入参
    }

    componentDidMount() {
        const { getCardcentreEnum } = this.props;
        getCardcentreEnum({ enumName: 'CouponIssueStatusEnum', type: 'centreState' });//发放状态
        getCardcentreEnum({ enumName: 'CouponTypeEnum', type: 'type' });//卡券类型
        getCardcentreEnum({ enumName: 'StateEnum', type: 'status' });//启用状态
    }

    // 新建攻略
    _createStudioRoom = () => {
        this.props.updateContent('creat');
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, type, state, cardTicket, orderStartTime, orderEndTime, status } = this.state;
        const { getCardcentreList, } = this.props;
        let startTime = orderStartTime != null ? orderStartTime.format('YYYY-MM-DD HH:mm') : null;
        let endTime = orderEndTime != null ? orderEndTime.format('YYYY-MM-DD HH:mm') : null;
        this.searchCache = {
            couponType: type.code,//卡券类型
            issueStatus: state.code,//发放状态
            couponName: cardTicket,//卡券名称
            issueStartTime: startTime, //发放时间开始时间
            issueEndTime: endTime, // 发放时间结束时间
            status: status.code,//启用状态
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        getCardcentreList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ type: {}, state: {}, status: {}, cardTicket: '', orderStartTime: null, orderEndTime: null }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.searchCache = { ...this.searchCache, pageSize, pageNum };
        this.props.getCardcentreList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageSize, pageNum }); // 【第5步：缓存分页状态】
    }


    // 表格操作  
    _tableAction = (item, type, value) => {
        const { getCardcentreList } = this.props;
        switch (type) {
            case 'detail':
                this.props.updateContent('detail', item);
                break;
            case 'switch':// 开启状态
                this.setState({
                    currentOpenMode: 'switch',
                    openModeParam: { ...item, switchState: value ? '1' : '0' },
                });
                break;
            case 'edit':
                this.props.updateContent('edit', item);
                break;
            case 'inventory'://库存
                this.setState({
                    currentOpenMode: 'inventory',
                    openModeParam: item,
                });
                break;
            case 'delete'://删除
                this.setState({
                    currentOpenMode: 'delete',
                    openModeParam: item
                });
                break;
            case 'getDetail'://明细
                {
                    const { couponName, ...restState } = value;
                    http('/?cmd=com.xqxc.api.pig.mis.biz.user.marketing.CouponMisService.couponStatistics', { id: item }, 'POST')
                        .then((res = {}) => {
                            this.setState({
                                currentOpenMode: 'data',
                                openModeParam: { ...res.result, couponName, id: item }
                            });
                        }).catch((reject = {}) => {
                            message.error(reject.message);
                        });
                }
                break;
        }
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'switch'://开启状态
                return <PopconfirmModal data={this.state.openModeParam} closeMode={this._closeMode} />;
            case 'delete'://删除
                return <DeleteModal data={this.state.openModeParam} closeMode={this._closeMode} />;
            case 'inventory'://库存
                return <InventoryModal title='库存' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            case 'data':
                return <ActivityDate
                    title={this.state.openModeParam.couponName}
                    visible={true}
                    data={this.state.openModeParam}
                    closeMode={this._closeMode}
                    history={this.props.history}
                />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this.props.getCardcentreList(this.searchCache);
        }
    }

    render() {
        const { type, cardTicket, state, orderStartTime, startPickerDisabled, orderEndTime,
            endPickerDisabled, status, } = this.state;
        const { cardcentreList } = this.props;
        const { centreState, centreType, centreStatus } = this.props.cardcentreEnum;


        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='卡券名称'
                                placeholder='请输入卡券名称'
                                value={cardTicket}
                                bindThis={this}
                                bindName='cardTicket'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='卡券类型'
                                placeholder='请选择'
                                renderData={centreType}
                                dataIndex='value'
                                keyIndex='code'
                                value={type.value}
                                bindThis={this}
                                bindName='type'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='发放时间'
                                value={orderStartTime}
                                disabled={startPickerDisabled}
                                format="YYYY-MM-DD HH:mm"
                                bindThis={this}
                                bindName='orderStartTime'
                            />
                            <XDatePicker
                                style={{ marginRight: '20px' }}
                                value={orderEndTime}
                                format="YYYY-MM-DD HH:mm"
                                disabled={endPickerDisabled}
                                bindThis={this}
                                bindName='orderEndTime'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='发放状态'
                                placeholder='请选择'
                                renderData={centreState}
                                dataIndex='value'
                                keyIndex='code'
                                value={state.value}
                                bindThis={this}
                                bindName='state'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='启用状态'
                                placeholder='请选择'
                                renderData={centreStatus}
                                dataIndex='value'
                                keyIndex='code'
                                value={status.value}
                                bindThis={this}
                                bindName='status'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: 'auto' }} label='新建卡券' onClick={this._createStudioRoom} />
                    </div>
                    <TableContent
                        renderData={cardcentreList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Marketing.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    updateContent: PropTypes.func, // 路由跳转
    cardcentreList: PropTypes.object,
    getCardcentreList: PropTypes.func,//卡券中心列表数据(action)
    cardcentreEnum: PropTypes.object,
    getCardcentreEnum: PropTypes.func,//枚举数据(action)
};

const mapStateToProps = (state) => {
    return {
        cardcentreList: state.cardcentre.cardcentreList,
        cardcentreEnum: state.cardcentre.cardcentreEnum,
    };
};
export default connect(mapStateToProps, model.actions)(Marketing);
